import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { BaseComponent } from '../../base/base.component';
import { ButtonData } from '../../../shared/public-api';

@Component({
  selector: 'admin-button',
  imports: [CommonModule],
  templateUrl: './button.component.html',
  styleUrl: './button.component.scss',
})
export class ButtonComponent extends BaseComponent<ButtonData> implements OnInit {
  icon = '';
  text = '';
  link = '';

  constructor() {
    super();
  }

  ngOnInit(): void {
    this.icon = this.data.icon;
    this.text = this.data.text;
    this.link = this.data.link;
  }
}
